import React, { memo } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import { Portal } from '@fluentui/react-components';
import styled from 'styled-components';
import SentryFallback from '../Sentry/SentryFallback';
import * as Sentry from '@sentry/react';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const RouteDiv = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  overflow: hidden auto;
  webkitoverflowscrolling: touch;
  background: ${p4Tokens.colorNeutralBackground1};
  left: 0;
  top: 0;
  transition: all 0.2s ease;
`;

const RouteModal = memo<any>(({ component: Content, ...rest }: { component: any } & { [key: string]: any }) => {
  //Using these hooks to preserve availability to children as props (Previously we rendered this modal from a render prop to <Route/>, but now it's just rendered as a child.
  const location = useLocation<{ login?: boolean }>();
  const history = useHistory();
  const match = useRouteMatch();
  const parentDOMNode = document.getElementById('app-content');

  return (
    <Portal mountNode={parentDOMNode}>
      <RouteDiv>
        <Sentry.ErrorBoundary fallback={SentryFallback}>
          <Content {...rest} location={location} history={history} match={match} />
        </Sentry.ErrorBoundary>
      </RouteDiv>
    </Portal>
  );
});

export default RouteModal;
